/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Feature_Year_RoundInputs */

const en_home_feature_year_round = /** @type {(inputs: Home_Feature_Year_RoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Year-round. Heated indoor in winter`)
};

const es_home_feature_year_round = /** @type {(inputs: Home_Feature_Year_RoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todo el año. Interior climatizado en invierno`)
};

const de_home_feature_year_round = /** @type {(inputs: Home_Feature_Year_RoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ganzjährig. Beheizte Halle im Winter`)
};

const zh_home_feature_year_round = /** @type {(inputs: Home_Feature_Year_RoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全年可学。冬季有室内加热场地`)
};

const ar_home_feature_year_round = /** @type {(inputs: Home_Feature_Year_RoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`على مدار السنة. صالة داخلية مُدفأة في الشتاء`)
};

const fr_home_feature_year_round = /** @type {(inputs: Home_Feature_Year_RoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toute l’année. Intérieur chauffé en hiver`)
};

const vi_home_feature_year_round = /** @type {(inputs: Home_Feature_Year_RoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quanh năm. Trong nhà có sưởi vào mùa đông`)
};

const sw_home_feature_year_round = /** @type {(inputs: Home_Feature_Year_RoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mwaka mzima. Ndani yenye joto wakati wa baridi`)
};

const th_home_feature_year_round = /** @type {(inputs: Home_Feature_Year_RoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ทั้งปี ห้องในร่มมีระบบทำความร้อนในฤดูหนาว`)
};

const bs_home_feature_year_round = /** @type {(inputs: Home_Feature_Year_RoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cijele godine. Grijani indoor zimi`)
};

const ja_home_feature_year_round = /** @type {(inputs: Home_Feature_Year_RoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通年営業。冬は暖房付きの屋内打席。`)
};

const ko_home_feature_year_round = /** @type {(inputs: Home_Feature_Year_RoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`연중 운영. 겨울에는 난방 실내 타석`)
};

const pt_home_feature_year_round = /** @type {(inputs: Home_Feature_Year_RoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O ano todo. Área coberta e aquecida no inverno`)
};

const it_home_feature_year_round = /** @type {(inputs: Home_Feature_Year_RoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutto l'anno. Riscaldata in inverno`)
};

const sv_home_feature_year_round = /** @type {(inputs: Home_Feature_Year_RoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Året runt. Uppvärmt inomhus på vintern`)
};

const nl_home_feature_year_round = /** @type {(inputs: Home_Feature_Year_RoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het hele jaar door. Verwarmd binnen in de winter`)
};

const da_home_feature_year_round = /** @type {(inputs: Home_Feature_Year_RoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hele året. Opvarmede indendørs båse om vinteren.`)
};

const nb_home_feature_year_round = /** @type {(inputs: Home_Feature_Year_RoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Året rundt. Oppvarmet innendørs om vinteren`)
};

const fi_home_feature_year_round = /** @type {(inputs: Home_Feature_Year_RoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avoinna ympäri vuoden. Talvella lämmitetty sisätila`)
};

const pl_home_feature_year_round = /** @type {(inputs: Home_Feature_Year_RoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przez cały rok. Zimą ogrzewana część kryta`)
};

const ru_home_feature_year_round = /** @type {(inputs: Home_Feature_Year_RoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Круглый год. Зимой — отапливаемая крытая зона`)
};

const tr_home_feature_year_round = /** @type {(inputs: Home_Feature_Year_RoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yıl boyu açık. Kışın ısıtmalı kapalı alan`)
};

const hi_home_feature_year_round = /** @type {(inputs: Home_Feature_Year_RoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वर्ष भर। सर्दियों में इनडोर गरम`)
};

const id_home_feature_year_round = /** @type {(inputs: Home_Feature_Year_RoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sepanjang tahun. Area indoor berpemanas saat musim dingin.`)
};

const ms_home_feature_year_round = /** @type {(inputs: Home_Feature_Year_RoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sepanjang tahun. Ruang tertutup berpemanas pada musim sejuk`)
};

const cs_home_feature_year_round = /** @type {(inputs: Home_Feature_Year_RoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Celoročně. V zimě vyhřívaná hala`)
};

const el_home_feature_year_round = /** @type {(inputs: Home_Feature_Year_RoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Όλο τον χρόνο. Θερμαινόμενος σκεπαστός χώρος τον χειμώνα`)
};

const he_home_feature_year_round = /** @type {(inputs: Home_Feature_Year_RoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`פתוח כל השנה. מתחם מקורה ומחומם בחורף.`)
};

const af_home_feature_year_round = /** @type {(inputs: Home_Feature_Year_RoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die hele jaar. Verhitte binnenshuise fasiliteit in die winter`)
};

const hu_home_feature_year_round = /** @type {(inputs: Home_Feature_Year_RoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egész évben nyitva. Télen fűtött fedett rész`)
};

/**
* | output |
* | --- |
* | "Year-round. Heated indoor in winter" |
*
* @param {Home_Feature_Year_RoundInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const home_feature_year_round = /** @type {((inputs?: Home_Feature_Year_RoundInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Feature_Year_RoundInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_feature_year_round(inputs)
	if (locale === "de") return de_home_feature_year_round(inputs)
	if (locale === "zh") return zh_home_feature_year_round(inputs)
	if (locale === "ar") return ar_home_feature_year_round(inputs)
	if (locale === "fr") return fr_home_feature_year_round(inputs)
	if (locale === "vi") return vi_home_feature_year_round(inputs)
	if (locale === "sw") return sw_home_feature_year_round(inputs)
	if (locale === "th") return th_home_feature_year_round(inputs)
	if (locale === "bs") return bs_home_feature_year_round(inputs)
	if (locale === "ja") return ja_home_feature_year_round(inputs)
	if (locale === "ko") return ko_home_feature_year_round(inputs)
	if (locale === "pt") return pt_home_feature_year_round(inputs)
	if (locale === "it") return it_home_feature_year_round(inputs)
	if (locale === "sv") return sv_home_feature_year_round(inputs)
	if (locale === "nl") return nl_home_feature_year_round(inputs)
	if (locale === "da") return da_home_feature_year_round(inputs)
	if (locale === "nb") return nb_home_feature_year_round(inputs)
	if (locale === "fi") return fi_home_feature_year_round(inputs)
	if (locale === "pl") return pl_home_feature_year_round(inputs)
	if (locale === "ru") return ru_home_feature_year_round(inputs)
	if (locale === "tr") return tr_home_feature_year_round(inputs)
	if (locale === "hi") return hi_home_feature_year_round(inputs)
	if (locale === "id") return id_home_feature_year_round(inputs)
	if (locale === "ms") return ms_home_feature_year_round(inputs)
	if (locale === "cs") return cs_home_feature_year_round(inputs)
	if (locale === "el") return el_home_feature_year_round(inputs)
	if (locale === "he") return he_home_feature_year_round(inputs)
	if (locale === "af") return af_home_feature_year_round(inputs)
	if (locale === "hu") return hu_home_feature_year_round(inputs)
	return en_home_feature_year_round(inputs)
});